import $ from 'jquery';
import Component from './index';
import Dropdown from './dropdown';

class Filters extends Component {
    mount() {
        this.dropdowns = [];

        this.createDropdowns();
        this.addEventListeners();
    }

    createDropdowns() {
        // Create dropdown instances for each instance in this filter.
        $('.js-dropdown').each((_, $dropdown) => {
            this.dropdowns.push(new Dropdown($dropdown));
        });
    }

    addEventListeners() {
        this.dropdowns.forEach(dd => {
            // Trigger change event when a dropdown selection is made.
            dd.on('select', (e, el) => {
                this.trigger('change', el.href, dd);
            });

            // Close all other dropdowns when one is opened.
            dd.on('open', () => {
                this.dropdowns.filter(dd2 => dd2 !== dd).forEach(dd2 => dd2.close());
            });
        });
    }

    unmount() {
        this.removeEventListeners();
        this.dropdowns.forEach(dd => dd.unmount());
    }

    removeEventListeners() {
        this.dropdowns.forEach(dd => {
            dd.off('selectLink');
            dd.off('open');
        });
    }
}

export default Filters;
